module.exports = __webpack_public_path__ + "1676dd54114aa91a7561213ebb0fedf7.png";